/* eslint-disable */
export default {
  allCalls: 'Kaikki puhelut',
  Unknown: 'Tuntematon',
  Multiple: 'Monta',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
